import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationProfessionalBodiesWConstants {
    static STEP_TITLE = "Professional bodies";
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static MARK_IMPLEMENTING_AGENT_AS_NOT_APPLICABLE_LABEL = "Are the implementing agent's details required?";
    static MARK_IMPLEMENTING_AGENT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME = "markImplementingAgentAsNotApplicable";
    static COPY_APPLICANT_DETAILS_TO_IMPLEMENTING_AGENT_LABEL = "Copy applicant details to implementing agent?";
    static COPY_APPLICANT_DETAILS_TO_IMPLEMENTING_AGENT_FORM_CONTROL_NAME = "copyApplicantDetailsToImplementingAgent";
    static MARK_ENGINEER_AS_NOT_APPLICABLE_LABEL = "Are the civil engineer's details required?";
    static MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME = "markEngineerAsNotApplicable";
    static COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL = "Copy applicant details to civil engineer?";
    static COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME = "copyApplicantDetailsToEngineer";
    static MARK_CONTRACTOR_AS_NOT_APPLICABLE_LABEL = "Are the contractor's details required?";
    static MARK_CONTRACTOR_AS_NOT_APPLICABLE_FORM_CONTROL_NAME = "markContractorAsNotApplicable";
    static COPY_APPLICANT_DETAILS_TO_CONTRACTOR_LABEL = "Copy applicant details to contractor?";
    static COPY_APPLICANT_DETAILS_TO_CONTRACTOR_FORM_CONTROL_NAME = "copyApplicantDetailsToContractor";
    static IMPLEMENTING_AGENT_LABEL = "Implementing agent / consultant";
    static ENGINEER_LABEL = "Civil engineer";
    static RESPONSIBLE_CONTRACTOR_LABEL = "Responsible contractor";
    static IMPLEMENTING_AGENT_FORM_CONTROL_NAME = "implementingAgentRecipient";
    static ENGINEER_FORM_CONTROL_NAME = "engineerRecipients";
    static RESPONSIBLE_CONTRACTOR_FORM_CONTROL_NAME = "responsibleContractorRecipient";
}
